import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { ProfileDetailsCard } from '../components/profile/ProfileDetailsCard';
import { ChangePasswordCard } from '../components/profile/ChangePasswordCard';
import { TwoFactorCard } from '../components/profile/TwoFactorCard';

/**
 * Your own account settings. Deliberately separate from the Settings page,
 * which is admin-only system configuration.
 *
 * Layout only. Each card owns its own form, state, and error handling.
 */
export const ProfilePage: React.FC = () => {
  return (
    <Box>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight={600}>
          My Profile
        </Typography>
      </Box>

      <Stack spacing={3}>
        <ProfileDetailsCard />
        <ChangePasswordCard />
        <TwoFactorCard />
      </Stack>
    </Box>
  );
};
